import {useMemo} from 'react'
import {
  Box, Flex, Table, Button, TextButton
} from '@binance/uikit'
import styled from 'styled-components'
import useOpenOrdersDataProvider from 'hooks/useOpenOrdersDataProvider'
import useOpenOrders from 'hooks/useOpenOrders'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useRouter from 'hooks/useRouter'
import useSymbolInfo from 'hooks/useSymbolInfo'
import {NoData} from './NoData'

const StyledTextButton = styled(TextButton)`
  :hover {
    text-decoration: underline;
  }
`

const getTitles = i18n => [
  {
    title: i18n['tradeHistory-timeTitle'] || 'Time',
    key: 'insertTime',
    direction: 'start',
    width: 158
  },
  {
    title: i18n['tradeHistory-symbolTitle'] || 'Symbol',
    key: 'symbol',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-orderTypeTitle'] || 'Order Type',
    key: 'disType',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-sideTitle'] || 'Side',
    key: 'disSide',
    direction: 'start',
    width: 110
  },
  {
    title: i18n.priceTitle || 'Price',
    key: 'price',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-filledTitle'] || 'Filled',
    key: 'executedQty',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-orderAmountTitle'] || 'Order Amount',
    key: 'origQty',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-tiggerConditionTitle'] || 'Trigger Condition',
    key: 'stopPrice',
    direction: 'start',
    width: 110
  },
  {
    title: '',
    key: 'button',
    width: 110
  }
]

export default function OpenOrdersPane ({i18n}) {
  const isLogin = useUserLoginStatus()
  const router = useRouter()
  const {symbol, lng = 'en'} = router.query
  useOpenOrdersDataProvider(symbol)
  const {symbolInfo} = useSymbolInfo()
  const {openOrders, cancelOrder} = useOpenOrders(symbolInfo)
  const hasOrders = openOrders?.length > 0
  return useMemo(() => {
    const tradeTypes = []
    const data = openOrders.map(el => {
      tradeTypes.push(el.type)
      el.button = (
        <StyledTextButton
          hover="#F0B90B44"
          color="#F0B90B"
          onClick={() => cancelOrder(i18n, lng, {orderId: el.orderId, symbol})}
        >
          {i18n.cancelBtnText || 'Cancel'}
        </StyledTextButton>
      )
      return el
    })
    return isLogin ? (
      <Flex width="100%" flexDirection="column">
        <Flex alignItems="center" justifyContent="flex-end" height="32px" bg="toolbar" px={2}>
          <Button
            variant="small"
            glossy={false}
            onClick={() => {
              hasOrders && cancelOrder(i18n, lng, {type: null})
            }}
          >
            {i18n['tradeHistory-cancelAllBtnText'] || 'Cancel All'}
          </Button>
          <Button
            variant="small"
            glossy={false}
            onClick={() => {
              hasOrders && tradeTypes.includes('LIMIT') && cancelOrder(i18n, lng, {type: 'LIMIT'})
            }}
          >
            {i18n['tradeHistory-cancelLimitOrderBtnText'] || 'Cancel Limit Order'}
          </Button>
          <Button
            variant="small"
            glossy={false}
            onClick={() => {
              hasOrders && tradeTypes.includes('STOP') && cancelOrder(i18n, lng, {type: 'STOP'})
            }}
          >
            {i18n['tradeHistory-cancelStopLimitOrderBtnText'] || 'Cancel Stop-Limit'}
          </Button>
        </Flex>
        <Box flex={1}>
          <Table
            data={data}
            title={getTitles(i18n)}
            height="185px"
            nodata={isLogin ? NoData('open order') : null}
          />
        </Box>
      </Flex>
    ) : null
  }, [openOrders, isLogin, i18n, cancelOrder, lng, symbol, hasOrders])
}
